// Collection of selector utils

/* Apply our 'standard' logic around determining if something's fetching
 *
 * We use logic based on the isFetching attribute, didInvalidate or the presence of details.
 */
export function isFetching (struct) {
  return struct.isFetching || struct.didInvalidate || !struct.details
}
